


























































































import Vue from 'vue';

export default Vue.extend({
  props: {},
  data() {
    return {
      items: [
        {
          title: 'accessibilityStatement.section.textContrast.title',
          issues: [
            {
              text: 'accessibilityStatement.section.textContrast.issues.0.text',
              link: '#wcag-1-4-3',
              wcag: 'WCAG 1.4.3',
              description: 'accessibilityStatement.section.textContrast.issues.0.description',
            },
            {
              text: 'accessibilityStatement.section.textContrast.issues.1.text',
              link: '#wcag-1-4-4',
              wcag: 'WCAG 1.4.4',
              description: 'accessibilityStatement.section.textContrast.issues.1.description',
            },
          ],
        },
        {
          title: 'accessibilityStatement.section.navigation.title',
          issues: [
            {
              text: 'accessibilityStatement.section.navigation.issues.0.text',
              link: '#wcag-2-1-1',
              wcag: 'WCAG 2.1.1',
              description: 'accessibilityStatement.section.navigation.issues.0.description',
            },
            {
              text: 'accessibilityStatement.section.navigation.issues.1.text',
              link: '#wcag-2-4-3',
              wcag: 'WCAG 2.4.3',
              description: 'accessibilityStatement.section.navigation.issues.1.description',
            },
          ],
        },
        {
          title: 'accessibilityStatement.section.information.title',
          issues: [
            {
              text: 'accessibilityStatement.section.information.issues.0.text',
              link: '#wcag-3-3-1',
              wcag: 'WCAG 3.3.1',
              description: 'accessibilityStatement.section.information.issues.0.description',
            },
            {
              text: 'accessibilityStatement.section.information.issues.1.text',
              link: '#wcag-3-3-2',
              wcag: 'WCAG 3.3.2',
              description: 'accessibilityStatement.section.information.issues.1.description',
            },
            {
              text: 'accessibilityStatement.section.information.issues.2.text',
              link: '#wcag-3-3-3',
              wcag: 'WCAG 3.3.3',
              description: 'accessibilityStatement.section.information.issues.2.description',
            },
          ],
        },
        {
          title: 'accessibilityStatement.section.naming.title',
          issues: [
            {
              text: 'accessibilityStatement.section.naming.issues.0.text',
              link: '#wcag-4-1-2',
              wcag: 'WCAG 4.1.2',
              description: 'accessibilityStatement.section.naming.issues.0.description',
            },
          ],
        },
      ] as AccessibilitySection[],
    };
  },
  methods: {
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
});
